module.exports = __webpack_public_path__ + "media/src/images/bg/bg2-554f307fcc17b524ef07b1909da108a8.jpg";